import { Paper, Text, TextInput, Tooltip } from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import { IconCopy } from "@tabler/icons-react";

type SignedPsbtPreviewProps = {
  signedAuctionPsbt: string;
};

export const SignedPsbtPreview = (props: SignedPsbtPreviewProps) => {
  const { copy, copied } = useClipboard({
    timeout: 500,
  });
  if (!props.signedAuctionPsbt) {
    return null;
  }

  return (
    <Paper p="sm" mt="sm" shadow="sm">
      <Text>Signed auction PSBT</Text>
      <TextInput
        mt="sm"
        size="sm"
        readOnly
        rightSection={
          <Tooltip label="Copied PSBT" opened={copied}>
            <IconCopy
              onClick={() => copy(props.signedAuctionPsbt)}
              size={20}
              cursor="pointer"
            />
          </Tooltip>
        }
        rightSectionWidth={42}
        value={props.signedAuctionPsbt}
      />
    </Paper>
  );
};
